import { Component, Input, Inject, AfterViewInit, ViewChild } from '@angular/core';
import { HttpService } from '../../http.service';
import { TableComponent } from '../table/table.component';

@Component({
  selector: 'app-admin-report-detail',
  templateUrl: './admin-report-detail.component.html',
  styleUrls: ['./admin-report-detail.component.scss']
})
export class AdminReportDetailComponent implements AfterViewInit {

  public summary:any = [];
  public is_init:boolean = false;
  private ids:any = []
  @ViewChild("history", { static: false }) wl: TableComponent;

  @Input() set setIDS(v:any) {
    this.ids = v;
  }

  @Input() type:any;

  constructor(
    private http: HttpService
      ) { 
//      this.type = this.data.type;
    }

  ngAfterViewInit(): void {
    this.is_init = true;
    this.get();

  }

  async get() {

    if(!this.is_init) {
      return;
    }

    let playerSummary = 
      { 
        post: {url: "/admin/company/admin/summary/details", data: {ids: this.ids, type: this.type}},
        disabled_pagenat: false,
        show_sum: true,
        fields: [
          {label: "GAME", type: 'string', key: 'vv'}, 
          {label: 'Debit/In', type: 'price', key: 'debit', sum: true, border_left: true, border_right: true}, 
          {label: 'Credit/Out', type: 'price', key: 'credit', sum: true, border_left: true, border_right: true}, 
          {label: 'Date', type: 'date', key: 'timestamp'}
        ]
      }

      if(this.type == 'bank') {
        playerSummary.fields = [
          {label: 'BANK', type: 'string', key: 'vv'}, 
          {label: 'Debit/In', type: 'price', key: 'debit', sum: true, border_left: true, border_right: true}, 
          {label: 'Credit/Out', type: 'price', key: 'credit', sum: true, border_left: true, border_right: true}, 
          {label: 'Bonus', type: 'price', key: 'bonus', sum: true, border_left: true, border_right: true}, 
          {label: 'Profit', type: 'price', key: 'game_profit', sum: true, border_left: true, border_right: true}, 
          {label: 'Date', type: 'date', key: 'timestamp'}
        ]
      }

      console.log(playerSummary)
      this.wl.init(playerSummary);
  }

}